const config = {
  books: [1, 2, 3, 4, 5, 6]
};

export default config;
